// See web/app/themes/jcf-theme/templates/partial/newsletter.twig

export default ((document, window) => {
  const open = () => {
    document.getElementById("thankyou").classList.add("open");
    document.getElementById("thankyou").classList.remove("closed");
  };

  const close = (e) => {
    if (e.target.id !== "thankyou__close") return;
    e.preventDefault();
    history.replaceState(null, null, " ");
    document.getElementById("thankyou").classList.remove("open");
    document.getElementById("thankyou").classList.add("closed");
  };

  // const gothash = (hash) => {
  //   if (hash && hash === "#thankyou") {
  //     document.addEventListener("click", close, false);
  //     open();
  //   }
  // };

  const thanks = () => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("thankyou")) {
      document.addEventListener("click", close, false);
      open();
    }
  };

  const init = () => {
    // gothash(location.hash)

    thanks();

    // window.addEventListener('hashchange', function() {
    //   gothash(location.hash)
    // }, false)
  };

  return {
    init: init,
  };
})(document, window);
